import { USER_JOINED_SITE } from './types'

const userJoinedSite = inDialog => ({
  type: USER_JOINED_SITE,
  payload: inDialog
})

export { userJoinedSite }
